import { ROUTES } from "@app/config/constants";
import { createFileRoute, Link } from "@tanstack/react-router";
import { ScrollText } from "lucide-react"; // Import icon

export const Route = createFileRoute("/mentions-legales")({
  staticData: {
    // Moved routeMeta content here
    title: "Mentions Légales",
    icon: <ScrollText className="w-5 h-5" />,
    permission: null, // Public page
    section: "Légal",
    order: 10,
  },
  component: MentionsLegalesComponent,
});

function MentionsLegalesComponent() {
  return (
    <div className="min-h-screen bg-base-200 p-8">
      <div className="max-w-4xl mx-auto bg-base-100 rounded-xl p-8">
        <Link to={ROUTES.APP.HOME} className="btn btn-ghost mb-4">
          ← Retour
        </Link>
        <h1 className="text-3xl font-bold mb-6">Mentions Légales</h1>
        <div className="prose">
          <p>Contenu des mentions légales à compléter...</p>
        </div>
      </div>
    </div>
  );
}
